// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__MBEqM","footer":"ReportModalFilter_footer__3Pico"};